export default __webpack_public_path__ + "static/media/45.547f32ce.png";